import React from "react";
import { PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";

import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import SchedulingSection from "./SchedulingSection";
import ContactSection from "./ContactSection";

import { contact } from "@/mock/zebraCarsMock";

export const ZebraCarsLanding = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${contact.phone}`;
  };

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="relative min-h-screen text-[var(--text-primary)] !bg-[#303030]">

      {/* Toaster za notifikacije – MOCK, bez backenda */}
      <Toaster position="top-right" richColors />

      {/* Header */}
      <header className="sticky top-0 z-30 border-b border-[var(--border-light)] bg-[color-mix(in_srgb,var(--bg-page)_80%,#020617_20%)] backdrop-blur-xl text-[var(--text-primary)]">
        <div className="max-w-[87.5rem] lg:px-10 flex items-center justify-between h-16 mx-auto px-5 !bg-[#303030]">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-[var(--bg-light)] flex items-center justify-center overflow-hidden">
              <img
                src={require("@/assets/viber_image_2026-02-02_21-16-48-412.jpg")}
                alt="Zebra Cars logo"
                className="w-full h-full object-contain" />

            </div>
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-semibold tracking-[0.12em] uppercase text-[var(--text-secondary)]">
                Zebra Cars
              </span>
              <span className="text-sm text-[var(--text-primary)]">
                Registracija vozila & tehnički pregled
              </span>
            </div>
          </div>
          <nav className="hidden md:flex items-center gap-4 text-sm">
            <button
              className="nav-link hidden md:inline-flex"
              onClick={() => scrollToSection("usluge")}>

              Usluge
            </button>
            <button
              className="nav-link hidden md:inline-flex"
              onClick={() => scrollToSection("radno-vreme")}>

              Radno vreme
            </button>
            <button
              className="nav-link hidden md:inline-flex"
              onClick={() => scrollToSection("kontakt")}>

              Kontakt
            </button>
            <Button
              variant="ghost"
              className="btn-primary px-6 py-2 rounded-full flex items-center gap-2"
              onClick={handleCallClick}>

              <PhoneCall className="w-4 h-4" />
              Pozovite nas
            </Button>
          </nav>
        </div>
      </header>

      {/* Glavni sadržaj */}
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SchedulingSection />
        <ContactSection />
      </main>

      {/* Footer */}
      <footer className="border-t border-[rgba(63,72,22,0.5)] bg-[#1a1c1b]">
        <div className="max-w-[87.5rem] mx-auto px-5 lg:px-10 flex flex-col md:flex-row items-center justify-between text-xs py-6 gap-4 text-[#888680]">
          <p>© {new Date().getFullYear()} Zebra Cars. Sva prava zadržana.</p>
          <p>Agencija za registraciju vozila i tehnički pregled – Novi Sad.</p>
        </div>
      </footer>
    </div>);

};

export default ZebraCarsLanding;